import Vue from "vue";
import "babel-polyfill";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import { Trans } from "./plugins/translation";
import { i18n } from "./plugins/vueI18n";

Vue.use(VueAxios, axios);
Vue.use(require("vue-moment"));
import moment from "moment";
import "moment/locale/es.js";
Vue.prototype.moment = moment;

process.env.NODE_ENV === "production"
  ? (axios.defaults.baseURL = "https://api.clinica.org/api")
  : (axios.defaults.baseURL =
      //"https://clinica-api-staging.azurewebsites.net/api");
      "http://100.85.128.6:5002/api");
axios.defaults.withCredentials = true;

Vue.config.productionTip = false;
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);

Vue.filter("locationNames", function(value) {
  if (!value) return value;
  switch (value) {
    case "Clinica Campesina Thornton":
    case "Clinica Campesina Dental Thornton":
      return "Clinica Thornton";
    case "Clinica Campesina Lafayette Clinic":
    case "Clinica Campesina Dental Lafayette":
      return "Clinica Lafayette";
    case "Clinica Campesina Pecos":
    case "Clinica Campesina Dental Pecos":
      return "Clinica Pecos";
    case "Clinica Campesina Westminster":
      return "Clinica Westminster";
    case "Clinica Campesina Peoples":
      return "Clinica Peoples";
    case "Clinica Campesina Alpine":
      return "Clinica Alpine";
    case "Clinica Campesina Nederland":
      return "Clinica Nederland";
    case "Clinica Campesina Gilpin County":
      return "Clinica Gilpin County";
    default:
      return value;
  }
});
Vue.filter("events", function(value, locale) {
  if (!value) return value;
  if (locale == "en") {
    switch (value) {
      // case "Tele-Health Visit":
      // case "Medical Phone Visit":
      //   return "Medical Phone Visit";
      // case "Tele-BHP":
      // case "Beahvioral Health Phone Visit":
      //   return "Behavioral Health Phone Visit";
      // case "Tele-Dental":
      //   return "Dental Phone Visit";
      default:
        return value;
    }
  }
  if (locale == "es") {
    switch (value) {
      case "Tele-Health Visit":
      case "Tele-Alpine":
      case "Phone Visit":
        return "Cita Medica por Teléfono";
      case "Tele-BHP":
      case "Behavioral Health Phone Visit":
        return "Cita de Salud Mental por Teléfono";
      case "Tele-Dental":
      case "Dental Phone Visit":
        return "Cita Dental por Teléfono";
      case "Wellness Exam":
        return "Cita Fisica";
      case "Routine Office Visit":
        return "Cita Medica";
      case "Prenatal Visit":
        return "Cita Prenatal";
      case "Financial Screening":
        return "Asistencia Financiera";
      case "COVID Vaccine (Pfizer)":
        return "Vacuna para el COVID-19 (Pfizer)";
      case "COVID Vaccine (Moderna)":
        return "Vacuna para el COVID-19 (Moderna)";
      case "COVID Vaccine (J&J)":
        return "Vacuna para el COVID-19 (J&J)";
      case "Flu & COVID":
        return "Vacuna para el COVID-19 y gripe";
      case "Flu Vaccine":
        return "Vacuna para gripe";
      case "COVID Vaccine":
      case "COVID Vaccine #2":
      case "COVID Vaccine #1":
        return "Vacuna para el COVID-19";
      case "COVID Vaccine - Drive Thru":
        return "Vacuna para el COVID-19 - Servicio al Carro";
      case "Virtual Visit":
      case "Virtual/Video Visit":
        return "Cita Virtual";
      case "Visit With My Medical Provider":
        return "Cita Con Mi Proveedor Médico";
      case "Visit With My Dental Provider":
        return "Cita Con Mi Proveedor Dental";
      case "ED/ER Follow Up":
        return "Seguimiento de Emergencias";
      case "Office Visit - Not a Physical":
        return "Cita Medica - No Fisica Anual";
      case "Wellness/Physical Visit":
        return "Cita Bienestar/Examen Físico";
      case "Visit With Any Medical Provider":
        return "Cita con cualquier Proveedor Médico.";
      default:
        return value;
    }
  }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
